import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { ValidationTextFieldProps } from "@/ui/Inputs/SystemValidationTextField";
import { phoneNumberValidationCallback } from "../pages/Profile/v2/GeneralDetails/useGeneralProfileDetailsState";

export function usePhoneValidation(): ValidationTextFieldProps {
	const { t } = useTranslation();

	return useMemo<ValidationTextFieldProps>(
		() => ({
			showValidWhenValid: "never",
			performValidation: "onlyAfterInitialChange",
			helperText: {
				invalid: t("oops.invalid.phone"),
			},
			validationCallback: phoneNumberValidationCallback,
		}),
		[t],
	);
}
